import styled from 'styled-components';

import { Grid } from '@notino/react-styleguide-v20';

export const StyledServicesWrapper = styled(Grid)`
  padding: 0;
`;
